/*
 * @Descripttion: API接口的统一出口
 * @Author: juanjuanhui
 * @Date: 2021-05-17 09:25:08
 * @LastEditors: likk
 * @LastEditTime: 2023-11-24 15:04:09
 */
import jgb from "@/api/jgb.js";

export default {
  jgb,
};
